import { tsUtils } from '@neo-one/ts-utils';
import { Types } from '../../constants';
import { IsHelper } from './IsHelper';
import { UnwrapHelper } from './UnwrapHelper';
import { WrapHelper } from './WrapHelper';
export class UnwrapMapHelper extends UnwrapHelper {
}
export class WrapMapHelper extends WrapHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Map;
    }
}
export class IsMapHelper extends IsHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Map;
    }
}
export const hasMap = (context, node, type) => tsUtils.type_.hasType(type, (tpe) => isMap(context, node, tpe));
export const isOnlyMap = (context, node, type) => tsUtils.type_.isOnlyType(type, (tpe) => isMap(context, node, tpe));
export const isMap = (context, node, type) => context.builtins.isInterface(node, type, 'Map') || context.builtins.isInterface(node, type, 'ReadonlyMap');

//# sourceMappingURL=map.js.map
